import { Box, Typography } from "@mui/material";
import React from "react";
import { GuestStatus, getGuestStatusBackgroundColor } from "src/types";
import { GUEST_STATUS_TO_LABEL } from "src/meetings/props";

export function GuestStatusIndicator(props: { status?: GuestStatus }) {
  if (!props.status) {
    return null;
  }

  const backgroundColor = getGuestStatusBackgroundColor(props.status);

  return (
    <Box
      sx={{
        width: "110px",
        borderRadius: "4px",
        px: "2px",
        py: "8px",
        textAlign: "center",
        backgroundColor,
      }}
    >
      <Typography sx={{ fontSize: "12px", color: "white" }} component="span">
        {GUEST_STATUS_TO_LABEL[props.status]}
      </Typography>
    </Box>
  );
}
